/** Shared Radical findings-toolbar control sizes (mic, AI, settings, delete). */
export const RADICAL_FINDINGS_BTN_SIZE_CLASS =
  "flex w-7 h-7 sm:w-8 sm:h-8 shrink-0 items-center justify-center";

export const RADICAL_FINDINGS_ICON_SIZE_CLASS =
  "w-3.5 h-3.5 sm:w-4 sm:h-4";

/** Radical-user mic button styles (sidebar controls). */
export function getRadicalMicButtonClass(isActive, variant = "sidebar") {
  const isCompact = variant === "compact";

  const sizeClass = isCompact
    ? RADICAL_FINDINGS_BTN_SIZE_CLASS
    : "flex h-8 w-8 shrink-0 items-center justify-center sm:h-9 sm:w-9";

  const colorClass = isActive
    ? "bg-red-500 dark:bg-red-600 hover:bg-red-600 dark:hover:bg-red-700 radical-mic-recording"
    : "bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600";

  return `${sizeClass} rounded-full transition-colors cursor-pointer ${colorClass}`;
}

export const RADICAL_COMPACT_MIC_ICON_CLASS = `${RADICAL_FINDINGS_ICON_SIZE_CLASS} text-gray-900 dark:text-gray-100`;

export const RADICAL_SIDEBAR_MIC_ICON_CLASS =
  "h-[18px] w-[18px] text-gray-900 dark:text-gray-100 sm:h-5 sm:w-5";
